import React from 'react'
import './add-towns-popup.css'

import Axios from 'axios'
import { baseUrl } from '../../assets/Animations'

const AddTownsPopup = (props) => {
    const [townArray, setTownArray] = React.useState([])

    const myToken = localStorage.getItem('token')
    const myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }

    React.useEffect(() => {
        if(props.school === '') {
            Axios.get(`${baseUrl}/town`, myHeader)
            .then((res) => {
                setTownArray(res.data)
            })
            .catch((err) => {
                console.log(err)
            })
        } else {
            Axios.get(`${baseUrl}/town/${props.school.toUpperCase()}`, myHeader)
            .then((res) => {
                setTownArray(res.data)
            })
            .catch((err) => {
                console.log(err)
            })
        }
    }, [])

    const findAndSetSelectedTownToAddToTeacher = (id) => {
        for(let i = 0; i < townArray.length; i++) {
            if(townArray[i].id === id) {
                props.setListOfTowns((prev) => [...prev, townArray[i]])
            }
        }
    }

    const findAndDeleteTown = (id) => {
        let myTown = props.listOfTowns
        for(let i = 0; i < myTown.length; i++) {
            if(myTown[i].id === id) {
                myTown.splice(i, 1)
                props.setListOfTowns([...myTown])
            }
        }
    }

    const tryToClose = (id) => {
        if(id === 'add-instrument-popup-wrapper') {
            props.setTownsPopup(false)
        }
    }

    const saveAndClosePopup = () => {
        props.setTownsPopup(false)
    }

    return(
        <div className='add-instrument-popup-wrapper' id='add-instrument-popup-wrapper' onClick={(e) => tryToClose(e.target.id)}>
            <div className='add-instrument-popup'>
                <h1>Add Towns to Teacher</h1>
                {props.listOfTowns.map((town) => 
                    <div className='add-inst__inst-list' key={town.id}>
                        <p className='remove-inst-x-inst-popup' onClick={() => findAndDeleteTown(town.id)}>X</p>
                        <p className='add-instrument-popup-instrument'>{town.townName}</p>
                    </div>
                )}
                <div className='inst-dropdown-wrapper'>
                    <select className='inst-dropdown' onChange={(e) => findAndSetSelectedTownToAddToTeacher(e.target.value)} value={{}}>
                        <option value={{}}>Choose Town</option>
                        {townArray.map((town) => <option key={town.id} value={town.id}>{town.townName}</option>)}
                    </select>
                </div>
                <div className='add-inst__save-btn__wrapper'>
                    <div className='add-inst__save-btn' onClick={() => saveAndClosePopup()}>Save Towns</div>
                </div>
            </div>
        </div>
    )
}
export default AddTownsPopup